import {createAction} from "redux-act";
import {IUser} from "modules/reducers";
import {IFormError} from "modules/types";
import {ButtonType} from "modules/enums";

export const requestUser = createAction();
export const requestUserSuccess = createAction<IUser>();
export const requestUserFailed = createAction();

export interface IUpdateUserPayload {
	username: string;
	firstName: string;
	lastName: string;
	favoriteTeam: number;
}

export interface IUpdateTeamName {
	name: string;
}

export const updateUser = createAction<IUpdateUserPayload>();
export const updateUserSuccess = createAction<IUser>();
export const updateUserFailed = createAction<IFormError>();

export interface IChangeAvatarPayload {
	id: number | null; // if null avatar will delete
}

export const changeAvatar = createAction<IChangeAvatarPayload>();
export const changeAvatarSuccess = createAction<IUser>();
export const changeAvatarFailed = createAction();
export const changeAvatarButtonType = createAction<ButtonType>();

export interface IChangePasswordPayload {
	password: string;
}

export const changePassword = createAction<IChangePasswordPayload>();
export const changePasswordSuccess = createAction<IUser>();
export const changePasswordFailed = createAction<IFormError>();

export const setUserError = createAction<IFormError>();
export const setChangePasswordError = createAction<IFormError>();
export const clearChangePasswordError = createAction<string | void>();
export const clearUserError = createAction<string | void>();

export const clearUserState = createAction();
